import { useTranslation } from 'react-i18next';

import { Spinner } from '@/lib/components/Util/Spinner';
import { Flex } from '@/lib/v2/components/Layout/Stack';

export const V1TransitionSwitch = ({ enabled }: { enabled: boolean }) => {
  const { t } = useTranslation();
  return (
    <>
      {enabled && (
        <div
          style={{
            position: 'absolute',
            height: 'calc(100vh - 64px)',
            width: '100%',
            backdropFilter: 'blur(10px) brightness(66%)',
            zIndex: '1000',
          }}
        >
          <Flex column alignment="center" itemAlignment="center">
            <Spinner />
            <span className="text-white">{t('V1_SWITCH.loading')}</span>
          </Flex>
        </div>
      )}
    </>
  );
};
